import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-50 to-blue-100 border-b border-blue-200 px-6 py-8">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-4">
            <ArrowLeft className="h-4 w-4" />
            Back to platform
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          <p className="text-gray-600 mt-2">Updated July 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12 space-y-8 text-gray-700">
        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">Terms of Service</h2>
          <p className="text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-4">
            These Terms of Service are currently being finalized. A comprehensive version covering service usage, liability limitations, dispute resolution, and other legal terms will be available shortly.
          </p>
        </section>

        <section>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Key Points</h3>
          <ul className="list-disc list-inside space-y-2 ml-2">
            <li>By using Yansar's services, you agree to comply with these Terms of Service</li>
            <li>You are responsible for maintaining the confidentiality of your account credentials</li>
            <li>You agree not to use the platform for any unlawful or unauthorized purposes</li>
            <li>Yansar reserves the right to terminate access for violations of these terms</li>
          </ul>
        </section>

        <section>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Contact Us</h3>
          <p>
            For questions about our Terms of Service, contact us at{" "}
            <a href="mailto:legal@yansarconsulting.com" className="text-blue-600 hover:underline">
              legal@yansarconsulting.com
            </a>
          </p>
        </section>

        <div className="border-t border-gray-300 pt-6 text-xs text-gray-500">
          <p>Yansar Consulting Services — Effective July 2026</p>
        </div>
      </div>
    </div>
  );
}
